import Vue from 'vue'
import Router from 'vue-router'
import store from './store';

import Register from './components/Account/Register.vue'
import Forgot from './components/Account/Forgot.vue'
import Reset from './components/Account/Reset.vue'
import Login from './components/Account/Login.vue'
import Dashboard from './components/Dashboard/index.vue'
import Email from './components/Email/index.vue'
import Stores from './components/Stores/index.vue';
import Attend from './components/Stores/Attend.vue';
import Profile from './components/Profile.vue'
import Logout from './components/Account/Logout.vue'
import LeadSegmentations from './components/LeadSegmentations/index.vue'
import Transactions from './components/Transactions.vue'
import Integrations from './components/Integrations/index.vue'
import Attendants from './components/Attendants/Index.vue'
import Leads from './components/Leads/Index.vue'
import IntegrationsGoogle from './components/Integrations/Google/Index.vue'
import Invite from './components/Invite/Index.vue'
import Messages from './components/Messages/Index.vue'
import Reports from './components/Reports/Index.vue'
import AttendingSchedules from './components/Attending/schedule/Index.vue'
import Paid from './components/Attending/confirmedpayments/Index.vue'
import Expired from './components/Attending/expired/Index.vue'
import Conection from './components/whatsapp/sessions/Index.vue'
import Notifications from './components/whatsapp/notifications/Index.vue'
import page_temp from './components/whatsapp/page_temporaria/cadastro_session.vue'

Vue.use(Router)

const isAuthenticaded = () => (store.state.user || (localStorage.getItem('user') && localStorage.getItem('access_token')));

const auth = ((to, from, next) => {
    if (isAuthenticaded())
        return next();
    
    return next('/login');
});

const guest = ((to, from, next) => {
    if (isAuthenticaded())
        return next('/dashboard');

    return next();
});

export default new Router({
    mode: 'history',
    base: process.env.VUE_APP_URL,
    routes: [
        {
            path: '/profile',
            name: 'profile',
            component: Profile,
            beforeEnter: auth
        },
        {
            path: '/register/:email?',
            name: 'register',
            component: Register,
        },
        {
            path: '/login/:email?',
            name: 'login',
            component: Login,
            beforeEnter: guest
        },
        {
            path: '/forgot',
            name: 'forgot',
            component: Forgot,
            beforeEnter: guest
        },
        {
            path: '/transactions',
            name: 'Transactions',
            component: Transactions,
            beforeEnter: auth
        },
        {
            path: '/lead-segmentations',
            name: 'leadSegmentations',
            component: LeadSegmentations,
            beforeEnter: auth
        },
        {
            path: '/email',
            name: 'email',
            component: Email,
            beforeEnter: auth
        },
        {
            path: '/',
            name: 'home',
            redirect: '/dashboard'
        },
        {
            path: '/dashboard',
            name: 'dashboard',
            component: Dashboard,
            beforeEnter: auth
        },
        {
            path: '/stores',
            name: 'stores',
            component: Stores,
            beforeEnter: auth
        },
        {
            path: '/leads',
            name: 'leads',
            component: Leads,
            beforeEnter: auth
        },
        {
            path: '/logout',
            name: 'logout',
            beforeEnter: auth,
            component: Logout,
        },
        {
            path: '/integrations',
            name: 'integrations',
            beforeEnter: auth,
            component: Integrations,
        },
        {
            path: '/attendants',
            name: 'attendants',
            beforeEnter: auth,
            component: Attendants,
        },
        {
            path: '/messages',
            name: 'messages',
            beforeEnter: auth,
            component: Messages,
        },
        {
            path: '/reports',
            name: 'reports',
            beforeEnter: auth,
            component: Reports,
        },
        {
            path: '/integrations/google',
            name: 'integrationsGoogle',
            beforeEnter: auth,
            component: IntegrationsGoogle,
        },
        {
            path: '/invite/:token/:answer',
            name: 'handleInvite',
            component: Invite,
        },
        {
            path: '/store/attend/:uuid',
            name: 'attendStore',
            component: Attend,
        },
        {
            path: '/forgot/:token/:email',
            name: 'reset',
            component: Reset,
        },
        {
            path: '/attending-schedules',
            name: 'attendingSchedules',
            component: AttendingSchedules,
        },
        {
            path: '/sessions',
            name: 'sessions',
            component: Conection,
        },
        {
            path: '/notifications',
            name: 'notifications',
            beforeEnter: auth,
            component: Notifications,
        },
        {
            path: '/paid',
            name: 'paid',
            beforeEnter: auth,
            component: Paid,
        },        
        {
            path: '/expired',
            name: 'expired',
            beforeEnter: auth,
            component: Expired,
        },
        {
            path: '/cadastro_session',
            name: 'cadastro_session',
            beforeEnter: auth,
            component: page_temp,
        },
        /*{
          path: '/about',
          name: 'about',
          // route level code-splitting
          // this generates a separate chunk (about.[hash].js) for this route
          // which is lazy-loaded when the route is visited.
          /*component: () => import( webpackChunkName: "about"  './views/About.vue')
        }*/
    ]
})